const ParamedicChiefs = () => {
  return (
    <div>
      <p>
        <strong>Team:</strong> Lauren Ngo, Sarina Wong
      </p>
      <br />
      <p>
        Paramedic Chiefs of Canada comprises of paramedic leaders who work to
        support paramedicine services across Canada.
      </p>
      <br />
      <p>
        Our client wanted a modern logo that conveyed 10 principles to emphasize
        the integration of healthcare throughout all health sectors. The 10
        fragments of the logo represent the principles and their connection. The
        maple leaf in the centre symbolizes Canada and the paramedicine
        community, as well as continuous growth.
      </p>
    </div>
  );
};

export default ParamedicChiefs;
